module.exports = __webpack_public_path__ + "static/media/furniture-7.1a1e3246.jpg";